export default __webpack_public_path__ + "static/media/iconSchool.7555267f.svg";